export default function convertInlineToAttributes(inline) {
  return {
    entity: {
      type: inline.type,
      data: inline.data.toJS ? inline.data.toJS() : {}
    }
  };
}